import script from "./NewsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./NewsWidget.vue?vue&type=style&index=0&id=cb6c0d0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb6c0d0a"]])

export default __exports__